import React from 'react'
import Bredcrumb from '../../Bredcrumb/Main'
import BGImg from "../../../assets/images/bread_crumb_bg.png"
import BGImg1 from "../../../assets/images/bread_crumb_bg_one.png"
import BGImg2 from "../../../assets/images/bread_crumb_bg_two.png"
import Onoff from '../Menfaq/Onoff'
import First from '../Menfaq/First'

const Main = ({ brdcum }) => {

    return (
        <>
            {brdcum.b1 &&
                <Bredcrumb no={1} title="Have questions? look here" paragraph="Lorem Ipsum is simply dummy text of the printing and typesetting" tag="Faq" bgimg={BGImg} />
            }

            {brdcum.b2 &&
                <Bredcrumb no={2} title="Have questions? look here" paragraph="Lorem Ipsum is simply dummy text of the printing and typesetting" tag="Faq" bgimg={BGImg1} />
            }

            {brdcum.b5 &&
                <Bredcrumb no={5} title="Have questions? look here" paragraph="Lorem Ipsum is simply dummy text of the printing and typesetting" tag="Faq" bgimg={BGImg} />
            }

            {brdcum.b3 &&
                <Bredcrumb no={3} title="Have questions? look here" paragraph="Lorem Ipsum is simply dummy text of the printing and typesetting" tag="Faq" />
            }

            {brdcum.b4 &&
                <Bredcrumb no={4} title="Have questions? look here" paragraph="Lorem Ipsum is simply dummy text of the printing and typesetting" tag="Faq" bgimg={BGImg2} />
            }

            <Onoff />
            <First />
        </>
    )
}

export default Main